import { Button, OutlinedInput, Stack, Typography } from "@mui/material";
import React, { useState } from "react";

type Props = {
  text: string;
  onClick: (verificationCode: string) => void;
};

export const TwoFactorVerificationForm = ({ onClick, text }: Props) => {
  const [verificationCodeInput, setVerificationCodeInput] = useState("");

  return (
    <Stack direction="column" gap={2}>
      <Typography
        align="center"
        variant="h6"
        color="primary.main"
        sx={{ mt: 2, fontWeight: "bold" }}
      >
        {text}
      </Typography>

      <OutlinedInput
        fullWidth
        type="number"
        placeholder="****"
        value={verificationCodeInput}
        onChange={(e) => setVerificationCodeInput(e.target.value)}
        sx={{ my: 2, "& input": { textAlign: "center" } }}
      />

      <Button
        variant="contained"
        onClick={() => onClick(verificationCodeInput)}
        disabled={verificationCodeInput.length !== 4}
        sx={{ textTransform: "uppercase" }}
      >
        Envoyer
      </Button>
    </Stack>
  );
};
